import { createIcon } from '@chakra-ui/icons';

export const Contactless = createIcon({
  displayName: 'Contactless',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.193359 5.10301L0.60584 4.69054C4.13683 1.15956 9.86171 1.15956 13.3927 4.69054L13.8052 5.10301L12.9802 5.92802L12.5677 5.51555C9.49235 2.44015 4.50618 2.44015 1.4308 5.51555L1.01832 5.92802L0.193359 5.10301Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.84375 7.33618L2.25623 6.92371C4.876 4.3039 9.12345 4.3039 11.7433 6.92371L12.1557 7.33618L11.3308 8.16113L10.9183 7.74866C8.75414 5.58449 5.24534 5.58449 3.08119 7.74866L2.66871 8.16113L1.84375 7.33618Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.49219 9.56921L3.90467 9.15673C5.61321 7.4482 8.3833 7.4482 10.0918 9.15673L10.5044 9.56921L9.67935 10.3942L9.26687 9.98169C8.01399 8.72875 5.98253 8.72875 4.72962 9.98169L4.31714 10.3942L3.49219 9.56921Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.14258 11.8022L5.55506 11.3898C6.35237 10.5924 7.6451 10.5924 8.4424 11.3898L8.85487 11.8022L8.02992 12.6272L7.61745 12.2147C7.27573 11.873 6.72174 11.873 6.38002 12.2147L5.96755 12.6272L5.14258 11.8022Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
